<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header" >
      <b-button variant="outline" @click="markAsRead()">
        <i class="fa fa-bell fa-lg"></i>
        <b-badge v-if="countUnRead > 0" pill variant="danger">{{countUnRead}}</b-badge>
      </b-button>
    </template>
    <template slot="dropdown">
      <div class="dropdown-custom">
        <b-dropdown-header v-if="lstNotifications.length == 0" tag="div" class="text-center"><strong>No tienes notificaciones</strong></b-dropdown-header>   
        <b-dropdown-header v-else tag="div" class="text-center"><strong>Tienes {{lstNotifications.length}} notificaciones </strong></b-dropdown-header>   
        <div class="dropdown-custom-scroll">
          <b-dropdown-item v-for="item in lstNotifications" :key="item.id" :value="item.id" class="list-notification" @click="openURL(item.data.url)" >

            <div class="row">
              <div class="w10 ml-2 mt-2 mr-1">
                <i :class="item.data.class" class="fa-2x"></i>
              </div>
              <div class="w80">
                <p> {{item.data.title}}</p>
                <p><strong>{{item.data.message}}</strong></p>
              </div>
            </div>

            <!-- <p><i class="fa fa-calendar text-primary"></i> <small class="text-muted">{{item.created_at}}</small></p> -->
          </b-dropdown-item>
        </div>
      </div>
    </template>
  </AppHeaderDropdown>  

</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
export default {
  name: 'DefaultHeaderDropdownNotif',
  components: {
    AppHeaderDropdown
  },
  data: () => {
    return { 
      token: localStorage.getItem('token'),
      auth: JSON.parse(localStorage.getItem('auth')),
      lstNotifications: [],
      countUnRead: 0
    }
  },
  mounted(){
    this.getNotificatiosUnRead()
    this.getNotificatios()
  },
  methods:{
    getNotificatios(){
      showLoader()
      let user_id = this.auth[0].id        
      this.lstNotifications = []

      // CARGAR EL LISTADO DE NOTIFICAIONES DE ESTE USUARIO
      this.$http.get(`${this.$urlApi}notifications/user/${user_id}?token=${this.token}`).then(response => {
        
        this.lstNotifications = response.data.data
        /*console.log(lstNotificationsAux)
        return false

        for (var i = 0; i < lstNotificationsAux.length; i++) {
          var item = lstNotificationsAux[i]
          var data = JSON.parse(item.data)

          var notifications = {
            id: item.id,
            created_at: item.created_at,
            message: data.message,
            notifiable_id: item.notifiable_id,
            notifiable_type: item.notifiable_type,
            read_at: item.read_at,
            type: item.type,
            updated_at: item.updated_at
          }

          this.lstNotifications.push(notifications)
        }*/
        
      }, error => {
        console.log(error)
        this.errores = getMsgError(error)
      })
      hideLoader()
    },
    getNotificatiosUnRead(){
      let user_id = this.auth[0].id
      
      this.$http.get(`${this.$urlApi}notifications/unread/user/${user_id}?token=${this.token}`).then(response => {
        this.countUnRead = response.data.data
      }, error => {
        console.log(error)
      })
    },
    markAsRead(){
      
      if(this.countUnRead == 0) return false

      let user_id = this.auth[0].id
           
      this.$http.post(`${this.$urlApi}notifications/read/user/${user_id}?token=${this.token}`).then(response => {
        //console.log(response)
        this.getNotificatiosUnRead()
      }, error => {
        console.log(error)
      })
      
    },
    openURL(url){
      if(url !== undefined) location.href = url
    }
  }
}
</script>
